import React from 'react';
import { Select } from 'semantic-ui-react';

const options = [
    { value: 15, text: '00:15' },
    { value: 30, text: '00:30' },
    { value: 60, text: '01:00' },
];

function StepSelect({ meta: _meta, ...props }) {
    return <Select options={options} {...props} />;
}

export default StepSelect;
